import { render, staticRenderFns } from "./chengzhen.vue?vue&type=template&id=6d2a6618&scoped=true&"
import script from "./chengzhen.vue?vue&type=script&lang=js&"
export * from "./chengzhen.vue?vue&type=script&lang=js&"
import style0 from "./chengzhen.vue?vue&type=style&index=0&id=6d2a6618&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a6618",
  null
  
)

export default component.exports